var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-search-browse",
    {
      key: _vm.refresh,
      ref: "browse",
      staticClass: "sale-search-browse",
      attrs: {
        "data-source": _vm.dataSource,
        "clear-view-settings-filters": _vm.clearViewSettingsFilters,
        "allow-view-button": _vm.allowViewButton,
        "override-static-view-select": _vm.overrideStaticViewSelect,
        view: _vm.view,
        multiple: _vm.multiple,
      },
      on: {
        click: function ($event) {
          return _vm.onClick($event)
        },
        "select-changed": function ($event) {
          return _vm.onSelectChanged($event)
        },
      },
    },
    [
      _vm._t(
        "browse-action-buttons",
        function () {
          return [
            _c(
              "w-button",
              {
                directives: [
                  {
                    name: "tooltip",
                    rawName: "v-tooltip",
                    value: _vm.filterOnCrmId,
                    expression: "filterOnCrmId",
                  },
                ],
                class: { cancel: !_vm.crmFilterActive },
                on: {
                  click: function ($event) {
                    ;(_vm.crmFilterActive = !_vm.crmFilterActive), _vm.refresh++
                  },
                },
              },
              [
                _c("w-fa", {
                  staticClass: "no-margin",
                  attrs: { icon: "filter" },
                }),
              ],
              1
            ),
            _vm.bookYearSelect
              ? _c(
                  "div",
                  { staticClass: "bookyear-wrapper" },
                  [
                    _c("app-select-book-year", {
                      attrs: {
                        value: _vm.selectedBookYear,
                        "include-book-year0": "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.onBookYearChange($event)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.crmFilterActive
              ? _c(
                  "w-button",
                  {
                    staticClass: "ml",
                    on: {
                      click: function ($event) {
                        return _vm.createSaleEvent()
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$ct("common.add")) + " ")]
                )
              : _vm._e(),
          ]
        },
        { slot: "browse-action-buttons" }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }